<template>
    <BreadCrumb PageTitle="Ajouter une question" />
    <AddQuestion />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddQuestion from "@/components/Question/AddQuestion.vue";
  
    export default defineComponent({
      name: "AddQuestionPage",
      components: {
        BreadCrumb,
        AddQuestion,
      },
    });
  </script>